import { isSchema as e } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/get-property-description.ts
var t = {
	integer: {
		_default: "Integer numbers.",
		int32: "Signed 32-bit integers (commonly used integer type).",
		int64: "Signed 64-bit integers (long type)."
	},
	string: {
		date: "full-date notation as defined by RFC 3339, section 5.6, for example, 2017-07-21",
		"date-time": "the date-time notation as defined by RFC 3339, section 5.6, for example, 2017-07-21T17:32:28Z",
		password: "a hint to UIs to mask the input",
		base64: "base64-encoded characters, for example, U3dhZ2dlciByb2Nrcw==",
		byte: "base64-encoded characters, for example, U3dhZ2dlciByb2Nrcw==",
		binary: "binary data, used to describe files"
	}
}, n = (n) => {
	if (!e(n)) return null;
	let r = Array.isArray(n.type) ? n.type[0] : n.type;
	if (!r) return null;
	let i = t[r];
	return i ? i["format" in n && n.format || "contentEncoding" in n && n.contentEncoding || "_default"] ?? null : null;
};
//#endregion
export { n as getPropertyDescription };

//# sourceMappingURL=get-property-description.js.map